import React, { useEffect, useState } from 'react'
import Title from 'shared/components/Title'
import { toast } from 'libs/toast'
import constants from 'config/constants'
import * as R from 'ramda'
import AccountCompletionForm from '../../containers/AccountCompletionForm'
import { useLocation } from 'react-router-dom'
import { useHistory } from 'react-router'
import useAxios from 'hooks/useAxios'
import store from 'store'
import generatePassword from 'generate-password'
import { convertQueryParamStringToObject } from 'libs/convertQueryParamStringToObject'
import { Loader } from '../../shared/components/Loader'
import AuthenticationShell from 'shared/components/AuthenticationShell'
import Page from 'shared/components/Page'
import { signedInLogCallBack } from 'pages/Login/utils'
import { completeOAuthInOpenerOrNavigate } from 'libs/oauthIframeBridge'

const AccountCompletion = (props) => {
  const [userEmail, setUserEmail] = useState('')
  const [userPassword, setUserPassword] = useState('')
  const [userConnectionId, setUserConnectionId] = useState('')
  const [showWarning, setShowWarning] = useState(false)
  const [userLoginMethod, setUserLoginMethod] = useState('')

  const { fetch: authCodeTradeAPI, loading: isAccountCompletionPageLoading } = useAxios({
    url: 'sso/authentication/',
    method: 'post',
    skip: true,
    headers: {
      Authorization: '',
      'X-Workspace-Token': '',
    },
  })
  const location = useLocation()
  const history = useHistory()
  const referer = R.path(['state', 'prev', 'pathname'], location) || '/'
  const loginMethod = props.match.path === '/login/sso/complete/' ? 'sso' : null

  const generateRandomPassword = () => {
    const password = generatePassword.generate({
      length: 12,
      numbers: true,
      symbols: true,
      lowercase: true,
      uppercase: true,
    })
    return password
  }

  useEffect(() => {
    const { code, error_description } = convertQueryParamStringToObject(location.search)
    const requestPayload = {
      code: code,
      login_method: loginMethod,
      errorDescription: error_description,
    }

    if (requestPayload.errorDescription) {
      const errorDescriptionString = requestPayload.errorDescription.toString()
      const userHasUnauthorizedDomain = errorDescriptionString.includes(
        'Profile does not belong to the target'
      )
      if (userHasUnauthorizedDomain) {
        toast.error(
          'Login failed: Your domain is not authorized. Please contact Simplesat support for assistance.'
        )
        return history.push('/login/sso')
      }
    }

    if (!requestPayload.code) {
      return history.push('/signup')
    }

    authCodeTradeAPI({ data: requestPayload })
      .then((response) => {
        if (response.data.require_sso && !response.data.token) {
          // does require sso -> send user to sso login page
          history.push({
            pathname: '/login/',
            state: {
              ssoError: true,
            },
          })
        } else if (!response.data.token) {
          // No token -> send user to account completion
          setUserEmail(response.data.email)
          setUserPassword(generateRandomPassword())
          setUserConnectionId(response.data.connection_id)
          setShowWarning(response.data.domain_already_exists)
          setUserLoginMethod(response.data.login_method)
        } else if (response.data.token) {
          const login_method = response.data.login_method

          // Has token / does require otp -> send user to otp page
          const login_method_param = `&logged_in_method=${login_method}`

          if (response.data.require_otp) {
            history.push({
              pathname: '/login/two-factor/',
              search: location.search + login_method_param,
              state: {
                token: response.data.token,
                pathname: referer,
              },
            })
            // Has token / no require otp -> send user to dashboard
          } else {
            store.set(constants.simplesatTokenName, response.data.token)

            completeOAuthInOpenerOrNavigate(history, {
              pathname: '/',
              state: signedInLogCallBack(login_method),
              token: response.data.token,
            })
          }
        }
      })
      .catch((error) => {
        if (
          error.response &&
          error.response.status === 401 &&
          error.response.data.error === 'Invalid login method.'
        ) {
          toast.error(error.response.data)
          history.push({
            pathname: '/login/',
            state: {
              loginMethodError: true,
              availableLoginMethods: error.response.data.available_login_methods,
            },
          })
        } else if (error.response && error.response.status === 403) {
          toast.error(error.response.data)
          history.push('/signup')
        } else {
          toast.error(error.message)
          history.push('/login')
        }
      })
  }, [location.search, authCodeTradeAPI, history, referer, loginMethod])

  return (
    <Page>
      {isAccountCompletionPageLoading ? (
        <Loader />
      ) : userEmail ? (
        <AuthenticationShell headerText="Complete sign up">
          <Title title="Complete sign up" />
          <AccountCompletionForm
            history={history}
            email={userEmail}
            password={userPassword}
            connectionId={userConnectionId}
            showWarning={showWarning}
            loginMethod={userLoginMethod}
          />
        </AuthenticationShell>
      ) : null}
    </Page>
  )
}

export default AccountCompletion



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/pages/AccountCompletion/index.js